import { Button, Modal } from "react-bootstrap";

interface DeleteModalMessageProps {
    message: string;
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

function DeleteModalMessage({ message, show, onConfirm, onCancel }: DeleteModalMessageProps) {
    const handleClose = () => onCancel();
    const handleConfirm = () => onConfirm();

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Confirmação</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="phoenix-primary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={handleConfirm}>
                    Excluir
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteModalMessage;
